// @ts-nocheck
import { POPUP_AXIS, Select, SELECT_THEMES, Tabs, Text, getExperimentFlags } from 'platform-components';
import { useStableCallback } from 'platform-components/src/utils/hooks';
import qs from 'query-string';
import ym from 'react-yandex-metrika';
import React, { useEffect, useMemo, memo } from 'react';
import { useLocation } from 'react-router';
import { ExternalLink } from 'education-icons';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { getMe } from 'platform-components/src/components/user/selectors';

import { TEACHER_PUBLIC_GRADES } from 'common.components/user/user.constants';
import { useChangeGrade } from './useChangeGrade';
import './grade-select.scss';

interface Props {
    mix?: string;
    type?: 'select' | 'tabs';
    grades?: number[];
    showEgeTab?: boolean;
    defaultGrade?: number;
    onSelectGrade?: (grade: number) => void;
    selectedGrade?: number;
}

export const GradeSelect = memo(
    ({ mix, grades, type = 'select', showEgeTab = false, defaultGrade, onSelectGrade, selectedGrade }: Props) => {
        const { search } = useLocation();
        const query = qs.parse(search);
        const currentGrade = Number(selectedGrade ?? query.grade ?? defaultGrade);
        const availableGrades = useMemo(() => {
            return grades || TEACHER_PUBLIC_GRADES;
        }, [grades]);

        const handleSelectGradeWithQuery = useChangeGrade();
        const handleSelectGrade = useStableCallback(onSelectGrade || handleSelectGradeWithQuery);

        const experimentsFlags = useSelector(getExperimentFlags);
        const me = useSelector(getMe);

        const goToEge = () => {
            ym('reachGoal', 'teacher_classes_ege_click', {
                puid: me?.id,
                user_id: me?.yauid,
                experiments: experimentsFlags ? Object.keys(experimentsFlags).join(',') : null,
            });

            window.location.href = '/teacher-ege';
        };
        // если выбранный грейд отсутствует в списке доступных грейдов,
        // устанавливаем первый по счету
        useEffect(() => {
            const firstAvailableGrade = availableGrades[0];
            const isNeedToSetAvailableGrade =
                currentGrade && !availableGrades.includes(currentGrade) && firstAvailableGrade;
            if (isNeedToSetAvailableGrade) {
                handleSelectGrade(firstAvailableGrade, { isReplace: true });
            }
        }, [availableGrades, currentGrade, handleSelectGrade]);

        if (type === 'tabs') {
            return (
                <Tabs mix={cx('grade-select-tabs', mix)} theme={Tabs.THEME.ROUNDED}>
                    {availableGrades.map((grade) => {
                        const isSelected = grade === currentGrade;
                        const displayGrade = grade === 99 ? 'СПО' : grade;

                        return (
                            <Tabs.Tab id={grade} key={grade} onTabSelect={handleSelectGrade} selected={isSelected}>
                                <Text weight={isSelected ? Text.WEIGHT.M : Text.WEIGHT.S}>{displayGrade}</Text>
                            </Tabs.Tab>
                        );
                    })}
                    {showEgeTab && (
                        <Tabs.Tab id="ege" mix="ege-tab" onTabSelect={goToEge} selected={false}>
                            ЕГЭ <ExternalLink />
                        </Tabs.Tab>
                    )}
                </Tabs>
            );
        }

        return (
            <Select
                mix={cx('grade-select-selector', mix)}
                onFocus={() => {}}
                onSelect={({ target }) => handleSelectGrade(target.value)}
                popupAxis={POPUP_AXIS.END}
                theme={SELECT_THEMES.ROUNDED}
                value={currentGrade}
                width="100%"
            >
                {availableGrades.map((grade) => (
                    <Select.Option key={grade} value={grade}>
                        <Text id="gradeSelect.option.text" values={{ grade }} />
                    </Select.Option>
                ))}
            </Select>
        );
    }
);
